import Enum from "../../../../../../enums/Enum";

const DermatomesSacralEnum = new Enum({
    D_S1: {value: "S1- Buttock, thigh, and leg posterior"},
    D_S2: {value: "S2- Buttock, thigh, and leg posterior"},
    D_S3: {value: "S3 - Groin, medial thigh to knee"},
    D_S4: {value: "S4 - Perineum, genitals, lower sacrum"},
});

export default DermatomesSacralEnum;